module.exports = __webpack_public_path__ + "static/media/42_Print.364c54ae.png";